/* ==========================================================================
   MAIN KAFFEE — Interaktion
   Vanilla JS, keine Abhaengigkeiten. Animation nur ueber transform/opacity.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------- Reveals */
  function initReveal() {
    var els = $$('[data-reveal]');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });

    els.forEach(function (el) { io.observe(el); });
  }

  /* Staffelung innerhalb einer Gruppe: data-stagger am Container */
  function initStagger() {
    $$('[data-stagger]').forEach(function (group) {
      var step = parseInt(group.getAttribute('data-stagger'), 10) || 90;
      $$('[data-reveal]', group).forEach(function (el, i) {
        el.style.setProperty('--d', (i * step) + 'ms');
      });
    });
  }

  /* --------------------------------------------------------------- Hero */
  function initHero() {
    var hero = $('.hero');
    if (!hero) return;
    $$('[data-d]', hero).forEach(function (el) {
      el.style.setProperty('--d', el.getAttribute('data-d') + 'ms');
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { hero.classList.add('is-ready'); });
    });
  }

  /* ------------------------------------------------------------- Header */
  function initHeader() {
    var hdr = $('.hdr');
    if (!hdr) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        hdr.classList.toggle('is-stuck', window.scrollY > 8);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var burger = $('.burger');
    var mnav = $('.mnav');
    if (burger && mnav) {
      burger.addEventListener('click', function () {
        /* Menue exakt unter der Kopfzeile beginnen lassen — deren Position
           haengt davon ab, ob das Ankuendigungsband noch sichtbar ist. */
        var bottom = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom));
        document.documentElement.style.setProperty('--mnav-top', bottom + 'px');

        var open = mnav.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
      });
      window.addEventListener('resize', function () {
        if (!mnav.classList.contains('is-open')) return;
        var b = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom));
        document.documentElement.style.setProperty('--mnav-top', b + 'px');
      }, { passive: true });

      $$('a', mnav).forEach(function (a) {
        a.addEventListener('click', function () {
          mnav.classList.remove('is-open');
          burger.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        });
      });
    }
  }

  /* --------------------------------------------------------- Warenkorb
     Shopify Cart AJAX API. Kein localStorage — der Warenkorb liegt im Shop,
     damit Preise, Rabatte und Steuern serverseitig stimmen.                */

  var money = function (cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' \u20AC';
  };

  // Muss zu gratis_ab in snippets/versand-hinweis.liquid und zum
  // Versandtarif in den Shopify-Einstellungen passen. Seit 07.09.2026 bei
  // 35 €, weil der Rabattcode (10 %, ab 39 €) den Warenkorb sonst unter die
  // alte 39-€-Schwelle zog und der Kunde trotz Rabatt mehr zahlte.
  var FREE_SHIP = 4500;

  function api(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body || {})
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart request failed: ' + r.status);
      return r.json();
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function add(variantId, qty, sellingPlan) {
    var item = { id: variantId, quantity: qty || 1 };
    if (sellingPlan) item.selling_plan = sellingPlan;
    return api('/cart/add.js', { items: [item] })
      .then(function () { return getCart(); })
      .then(function (cart) {
        paint(cart);
        toast('Im Warenkorb');
        openCart();
      })
      .catch(function () { toast('Konnte nicht hinzugefügt werden'); });
  }

  function changeLine(line, qty) {
    return api('/cart/change.js', { line: line, quantity: qty })
      .then(function (cart) { paint(cart); })
      .catch(function () { toast('Änderung fehlgeschlagen'); });
  }

  function paint(cart) {
    if (!cart) return;

    $$('.cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('is-on', cart.item_count > 0);
      el.setAttribute('aria-label', cart.item_count + ' Artikel im Warenkorb');
    });

    var body = $('#cartBody');
    if (body) {
      if (!cart.items.length) {
        body.innerHTML =
          '<div class="empty">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
          '<path d="M3 5h2l2.2 10.4a2 2 0 0 0 2 1.6h7.4a2 2 0 0 0 2-1.6L20 8H6"/>' +
          '<circle cx="10" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/></svg>' +
          '<p>Noch nichts drin.</p><p style="font-size:.8rem">Zeit, das zu ändern.</p></div>';
      } else {
        body.innerHTML = cart.items.map(function (it, i) {
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_144x$1$2') : '';
          return '<div class="line">' +
            '<img src="' + img + '" alt="" width="72" height="72" loading="lazy">' +
            '<div><div class="line-name">' + it.product_title + '</div>' +
            '<div class="line-var">' + (it.variant_title || '') + '</div>' +
            '<div class="qty">' +
              '<button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Menge verringern">\u2212</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Menge erhöhen">+</button>' +
            '</div></div>' +
            '<div style="text-align:right">' +
              '<div class="line-price">' + money(it.final_line_price) + '</div>' +
              '<button type="button" class="line-rm" data-line="' + (i + 1) + '" data-q="0">entfernen</button>' +
            '</div></div>';
        }).join('');
      }
    }

    var sumEl = $('#cartSum');
    if (sumEl) sumEl.textContent = money(cart.total_price);

    var note = $('#cartShip');
    if (note) {
      // Derselbe Wortlaut wie in snippets/versand-hinweis.liquid, damit der
      // Text beim Nachladen nicht springt. cart.total_price ist der Betrag
      // nach Rabattcode, und genau darauf rechnet auch der Versandtarif.
      if (!cart.items.length) note.innerHTML = 'Kostenloser Versand ab ' + money(FREE_SHIP) + '.';
      else if (cart.total_price >= FREE_SHIP) note.innerHTML = '<b>Versand kostenlos.</b> Die Schwelle ist erreicht.';
      else note.innerHTML = 'Noch <b>' + money(FREE_SHIP - cart.total_price) + '</b> bis zum kostenlosen Versand. Darunter kommen ' + money(690) + ' dazu.';
    }
  }

  function openCart() {
    var d = $('#cart'), s = $('#scrim');
    if (!d) return;
    d.classList.add('is-on');
    if (s) s.classList.add('is-on');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var c = $('.drawer-hd .icon-btn', d);
    if (c) c.focus();
  }

  function closeCart() {
    var d = $('#cart'), s = $('#scrim');
    if (!d) return;
    d.classList.remove('is-on');
    if (s) s.classList.remove('is-on');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function initCart() {
    getCart().then(paint).catch(function () {});

    $$('[data-open-cart]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); getCart().then(paint); openCart(); });
    });
    $$('[data-close-cart]').forEach(function (b) { b.addEventListener('click', closeCart); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

    var body = $('#cartBody');
    if (body) {
      body.addEventListener('click', function (e) {
        var b = e.target.closest('[data-line]');
        if (!b) return;
        changeLine(parseInt(b.getAttribute('data-line'), 10), parseInt(b.getAttribute('data-q'), 10));
      });
    }

    /* Schnellkauf aus Produktkarten */
    $$('[data-add]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        add(b.getAttribute('data-add'), 1);
      });
    });

    /* Warenkorbseite */
    $$('[data-line-inc],[data-line-dec],[data-line-rm]').forEach(function (b) {
      b.addEventListener('click', function () {
        var line = b.getAttribute('data-line-inc') || b.getAttribute('data-line-dec') || b.getAttribute('data-line-rm');
        var row = b.closest('.line');
        var cur = parseInt(($('.qty span', row) || {}).textContent || '1', 10);
        var q = b.hasAttribute('data-line-rm') ? 0 : (b.hasAttribute('data-line-inc') ? cur + 1 : cur - 1);
        api('/cart/change.js', { line: parseInt(line, 10), quantity: q })
          .then(function () { location.reload(); });
      });
    });

    /* Produktformular: Variante, Preis, Bild */
    var pdForm = $('#pdBuy');
    if (pdForm) {
      var priceEl = $('#pdPrice'), imgEl = $('#pdImage');
      var hidden = $('#pdVariantId', pdForm);
      var submitBtn = $('button[type="submit"]', pdForm);

      /* Produkte mit mehreren Optionen (z. B. das 3er-Bundle) liefern die
         Variantenliste als JSON mit. Aus der gewaehlten Kombination wird die
         passende Variante gesucht.                                          */
      var variants = null;
      var raw = $('#pdVariants', pdForm);
      if (raw) { try { variants = JSON.parse(raw.textContent); } catch (e) { variants = null; } }

      function chosen() {
        var vals = [];
        $$('[data-opt-index]', pdForm).forEach(function (i) {
          if (i.checked) vals[parseInt(i.getAttribute('data-opt-index'), 10)] = i.value;
        });
        return vals;
      }

      function matchVariant(vals) {
        if (!variants) return null;
        for (var i = 0; i < variants.length; i++) {
          var o = variants[i].options, ok = true;
          for (var k = 0; k < vals.length; k++) { if (o[k] !== vals[k]) { ok = false; break; } }
          if (ok) return variants[i];
        }
        return null;
      }

      function sync() {
        if (variants) {
          var v = matchVariant(chosen());
          if (!v) return;
          if (hidden) hidden.value = v.id;
          if (priceEl) priceEl.textContent = money(v.price);
          if (submitBtn) {
            submitBtn.disabled = !v.available;
            submitBtn.textContent = v.available ? 'In den Warenkorb' : 'Diese Kombination ist nicht verfügbar';
          }
          return;
        }
        var r = $('input[name="id"]:checked', pdForm);
        if (!r) return;
        if (priceEl && r.dataset.price) priceEl.textContent = r.dataset.price;
        if (imgEl && r.dataset.image) imgEl.setAttribute('src', r.dataset.image);
      }

      /* Kaffee-Abo: zeigt den Abo-Preis, wenn ein Abo gewaehlt ist. */
      function aboPreis() {
        var sp = $('input[name="selling_plan"]:checked', pdForm);
        var pct = sp ? parseFloat(sp.getAttribute('data-abo-pct') || '0') : 0;
        var cents = null;
        if (variants) {
          var v = matchVariant(chosen());
          if (v) cents = v.price;
        } else {
          var r = $('input[name="id"]:checked', pdForm) || $('input[name="id"]', pdForm);
          if (r && r.getAttribute('data-cents')) cents = parseInt(r.getAttribute('data-cents'), 10);
        }
        if (cents === null || !priceEl) return;
        priceEl.textContent = money(Math.round(cents * (1 - pct / 100)));
      }

      $$('input[name="id"], [data-opt-index]', pdForm).forEach(function (i) {
        i.addEventListener('change', function () { sync(); aboPreis(); });
      });
      $$('input[name="selling_plan"]', pdForm).forEach(function (i) {
        i.addEventListener('change', aboPreis);
      });
      sync();

      pdForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = hidden ? hidden.value
               : (($('input[name="id"]:checked', pdForm) || $('input[name="id"]', pdForm) || {}).value);
        var sp = $('input[name="selling_plan"]:checked', pdForm);
        if (id) add(id, 1, sp && sp.value ? sp.value : null);
      });
    }

    /* Miniaturen auf der Produktseite */
    $$('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        var img = $('#pdImage');
        if (img) img.setAttribute('src', b.getAttribute('data-thumb'));
      });
    });
  }

  /* ------------------------------------------------------------- Toast */
  var toastTimer;
  function toast(msg) {
    var t = $('#toast');
    if (!t) return;
    $('.toast-msg', t).textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }

  /* --------------------------------------------------------- Akkordeon */
  function initAcc() {
    $$('.acc-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.acc-item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------------------------------------------------------- Formular */
  function initForms() {
    $$('form[data-validate]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var ok = true;

        $$('[required]', form).forEach(function (input) {
          var field = input.closest('.field') || input.closest('.check');
          var valid = input.type === 'checkbox' ? input.checked : input.value.trim() !== '';
          if (valid && input.type === 'email') {
            valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim());
          }
          if (field) field.classList.toggle('is-err', !valid);
          if (!valid && ok) { input.focus(); ok = false; }
        });

        if (!ok) return;

        var done = $('[data-form-done]', form.parentNode) || $('[data-form-done]');
        form.hidden = true;
        if (done) { done.hidden = false; done.focus(); }
      });

      $$('input, textarea', form).forEach(function (input) {
        input.addEventListener('input', function () {
          var field = input.closest('.field') || input.closest('.check');
          if (field) field.classList.remove('is-err');
        });
      });
    });
  }

  /* ------------------------------------------------------- Jahr im Footer */
  function initYear() {
    $$('[data-year]').forEach(function (el) { el.textContent = new Date().getFullYear(); });
  }

  /* ------------------------------------------------------------- Start */
  function safe(fn) {
    try { fn(); } catch (err) { if (window.console) console.error(err); }
  }
  function boot() {
    safe(initStagger);
    safe(initReveal);
    safe(initHero);
    safe(initHeader);
    safe(initCart);
    safe(initAcc);
    safe(initForms);
    safe(initYear);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
